<template>
  <v-card-actions
    class="justify-center text-center"
    style="background-color: white"
  >
    <slot></slot>
  </v-card-actions>
</template>

<script>
export default {}
</script>
